var map = {
	"./br.json": [
		"ce21",
		"chunk-c366264c"
	],
	"./de.json": [
		"101d",
		"chunk-c366264c"
	],
	"./en.json": [
		"6fa7"
	],
	"./es.json": [
		"00f5",
		"chunk-58bb2667"
	],
	"./fr.json": [
		"d0ef",
		"chunk-58bb2667"
	],
	"./gr.json": [
		"dad6",
		"chunk-3afe5c2e"
	],
	"./it.json": [
		"e643",
		"chunk-4ccb73b6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "83a8";
module.exports = webpackAsyncContext;